import { render, staticRenderFns } from "./organization-tasks.vue?vue&type=template&id=4fbe4438&"
import script from "./organization-tasks.vue?vue&type=script&lang=js&"
export * from "./organization-tasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports